










































































































































import { Component, Mixins } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import JobsearchReferralSearchBox from "@/components/jobsearch/JobsearchReferralSearchBox.vue";
import { JobsearchReferralSearchParams } from "@/components/jobsearch/JobsearchReferralSearchBox.vue";
import { JobsearchReferralRegistration } from "@/model/portal";

@Component({
  components: {
    JobsearchReferralSearchBox,
  },
})
export default class extends Mixins(AxiosMixin) {
  /** タブ情報 */
  private currentTab = 0;

  /** データ */
  private pendingItems: JobsearchReferralRegistration[] = [];
  private processingItems: JobsearchReferralRegistration[] = [];
  private completedItems: JobsearchReferralRegistration[] = [];

  /** 検索パラメータ保持 */
  private searchParams: JobsearchReferralSearchParams = {};

  /** ダイアログ */
  private updateDialog = false;
  private updateTargetItem: JobsearchReferralRegistration | null = null;
  private updateTargetStatus = 0;
  private adminNote = "";

  private pendingHeaders = [
    { text: "紹介者名", value: "referrer_name" },
    { text: "登録者名", value: "referred_name" },
    { text: "電話番号", value: "phone_number" },
    { text: "資格情報登録済み", value: "qualification_registered" },
    { text: "ステータス", value: "status" },
    { text: "登録日", value: "created_at" },
    { text: "操作", value: "actions", sortable: false },
  ];

  private processingHeaders = [
    { text: "紹介者名", value: "referrer_name" },
    { text: "登録者名", value: "referred_name" },
    { text: "電話番号", value: "phone_number" },
    { text: "資格情報登録済み", value: "qualification_registered" },
    { text: "ステータス", value: "status" },
    { text: "登録日", value: "created_at" },
    { text: "操作", value: "actions", sortable: false },
  ];

  private completedHeaders = [
    { text: "紹介者名", value: "referrer_name" },
    { text: "登録者名", value: "referred_name" },
    { text: "電話番号", value: "phone_number" },
    { text: "資格情報登録済み", value: "qualification_registered" },
    { text: "ステータス", value: "status" },
    { text: "登録日", value: "created_at" },
  ];

  private statusText(status: number): string {
    switch (status) {
      case 1:
        return "承認待ち";
      case 2:
        return "報酬送付対応中";
      case 3:
        return "完了";
      default:
        return "";
    }
  }

  private onSearch(searchObj: JobsearchReferralSearchParams): void {
    this.searchParams = searchObj;
    this.fetchList();
  }

  private fetchList(): void {
    this.postJsonCheck(
      window.base_url + "/api/admin/jobsearch-referral-registrations/get",
      this.searchParams,
      (res) => {
        this.pendingItems = res.data.pending_items || [];
        this.processingItems = res.data.processing_items || [];
        this.completedItems = res.data.completed_items || [];
      }
    );
  }

  private openUpdateDialog(
    item: JobsearchReferralRegistration,
    newStatus: number
  ): void {
    this.updateTargetItem = item;
    this.updateTargetStatus = newStatus;
    this.adminNote = "";
    this.updateDialog = true;
  }

  private updateStatus(): void {
    if (!this.updateTargetItem) return;
    this.postJsonCheck(
      window.base_url +
        "/api/admin/jobsearch-referral-registration/update-status",
      {
        id: this.updateTargetItem.id,
        status: this.updateTargetStatus,
        admin_note: this.adminNote,
      },
      () => {
        this.updateDialog = false;
        this.fetchList();
      }
    );
  }
}
